import { mixinPropertyUtils } from 'skypager-util/lib/properties'
import lodash from 'lodash'
import obj from 'lodash/object'

export function create (sourceObject, options = {}) {

}

export const createEntity = (object = {}, options = {}) => {
  const instance = mixinPropertyUtils(Object.assign({}, object), false)

  Object.keys(obj).forEach(
    (meth) => instance.hide(meth, (...args) => obj[meth](instance, ...args))
  )

  if (options !== false && (options && options.includeChain !== false)) {
    instance.hideGetter('chain', () => lodash.chain(instance))
  }

  instance.hide('toJSON', () => lodash.omit(instance, 'chain'))
  
  return instance
}

export default createEntity


// WEBPACK FOOTER //
// ./src/entity.js